/** Side panel → background: resolve tab URL (must match `ChromeEvents.GetCurrentTab` in extension). */
export const GetCurrentTabCommand = 'GetCurrentTab';

export {
  GetSharepointDataAction,
  GetSharepointPipelineDebugAction,
  GetSharepointSheetTabTitlesAction,
  GetSharepointWorkbookContextAction,
  InjectExcelSheetInterceptorAction,
  RequestRefreshSharepointSheetDataAction,
  SharepointActiveSheetChangedBroadcastAction,
  SharepointDataUpdatedAction,
  SharepointExcelActiveSheetChangedAction,
  SharepointExcelPrefetchInterceptBroadcastAction,
  SharepointExcelSheetTabObserverErrorAction,
  SharepointSheetDataInterceptedAction,
} from './sharepoint';

export const UpdateQuoteRequestDataAction = 'updateQuoteRequestData';
export const UpdateLoadBuildingSuggestionDataAction =
  'updateLoadBuildingSuggestionData';
export const AutoFetchQuotesAction = 'autoFetchQuotes';
export const QuoteSidebarPortName = 'drumkit-sidepanel-quote-sidebar';
export const QuotingPortalPageStateUpdatedAction =
  'quotingPortalPageStateUpdated';
